//export const QURESHI_ELECTRONICS = "QURESHI_ELECTRONICS_WITHOUT_FBR"
// export const QURESHI_ELECTRONICSWithFBR = "QURESHI_ELECTRONICS_WITH_FBR"
// export const QURESHI_ELECTRONICSWithOUTFBR = "QURESHI_ELECTRONICS_WITHOUT_FBR"

// export const COMPANYHEADER = "Qureshi Electronics"
// export const COMPANYHEADER = "Qureshi Furnitures"
// export const COMPANYHEADER = "The Woods"
// export const COMPANYHEADER = "Company Name"
// export const VERSION = "1.10"

export const QURESHI_ELECTRONICS = "QURESHI_ELECTRONICS_WITH_FBR"
export const QURESHI_ELECTRONICSWithFBR = "QURESHI_ELECTRONICS_WITH_FBR"
export const QURESHI_ELECTRONICSWithOUTFBR = "QURESHI_ELECTRONICS_WITHOUT_FBR"

export const COMPANYHEADER = "Qureshi Electronics"
// export const COMPANYHEADER = "POS Demo"

// export const COMPANYHEADER = "The Woods"
// export const COMPANYHEADER = "Company Name"
export const VERSION = "2.00"
export const LASTUPDATED = new Date("2025-04-23T00:00:00").toLocaleDateString("en-GB")


export const COMPANY_SHORT = "QE"
// export const COMPANY_SHORT = "POS"
export const COMPANY_FULL = "QURESHI ELECTRONICS"
// export const COMPANY_FULL = "POS Demo"
// export const COMPANY_SHORT = "TW"
// export const COMPANY_FULL = "THE WOODS"
export const COMPANY_TAGLINE = "Point of Sale Solution"
